<template>
    <div v-loading="loading" style="margin-top: 10px">
        <div class="form-box">
            <el-form ref="form" inline :model="queryForm" style="text-align: center">
                <el-form-item>
                    <el-input v-model="queryForm.name" clearable placeholder="Name"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="queryForm.phone" clearable placeholder="Phone"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-date-picker
                            clearable
                            v-model="queryForm.date"
                            type="daterange"
                            format="dd-MM-yyyy"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Start Date"
                            end-placeholder="End Date">
                    </el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-input clearable placeholder="Gate Ref" v-model="queryForm.gateRef"></el-input>
                </el-form-item>

                <el-button type="primary" @click="loadData" icon="el-icon-search" size="medium" circle></el-button>
                <el-button type="primary" @click="exportData" icon="el-icon-download" size="medium" circle></el-button>
            </el-form>
        </div>


        <el-table
                fit
                stripe
                class="data-table"
                :data="data">
            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="item in [
                        {prop:'bid',label:'Order ID.'},
                        {prop:'gatewayInvoice',label:'Gateway Ref'},
                        {prop:'userName',label:'Name'},
                        {prop:'phone',label:'Phone'},
                        {prop:'amount',label:'Amount'},
                        // {prop:'balance',label:'Balance'},
                        {prop:'updated',label:'Date',fmt:selfTimeFormat},
                    ]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>
        </el-table>
        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>


    </div>
</template>

<script>
    import {exportToups, toups} from '@/api/eazableAPI'
    import {excelRequestRequest} from "@/utils/ApiUtils";

    export default {
        name: "Toups",
        data: function () {
            return {
                loading: false,
                queryForm: {},
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0}
            }
        },
        methods: {
            loadData() {
                this.$pageUtils(this, toups)
            },
            exportData() {
                excelRequestRequest(this, exportToups);
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>

</style>
